import builder from '../builder';
import RatingStarRibbonDashed from '../../streamline-icons/light/rating-star-ribbon-dashed.svg';

export default builder(
  'IconRatingStarRibbonDashedLight',
  RatingStarRibbonDashed,
);
